import { ReactComponent as PieuvreIcon } from "assets/services/reservation/pieuvre.svg";
import { ReactComponent as WhiteboardIcon } from "assets/services/reservation/tableaublanc.svg";
import { ReactComponent as TelevisionIcon } from "assets/services/reservation/televiseur.svg";
import { ReactComponent as VideoProjectorIcon } from "assets/services/reservation/videoprojecteur.svg";
import { ReactComponent as WifiIcon } from "assets/services/reservation/wifi.svg";
import { ReactComponent as ColdDrinkIcon } from "assets/services/reservation/boissonfroide.svg";
import { ReactComponent as CoffeeIcon } from "assets/services/reservation/cafe.svg";
import { ReactComponent as WaterIcon } from "assets/services/reservation/eau.svg";
import { ReactComponent as ProjectionScreenIcon } from "assets/services/reservation/ecranprojection.svg";
import { ReactComponent as SpeakersIcon } from "assets/services/reservation/enceintes.svg";
import { ReactComponent as HighSpeedInternetIcon } from "assets/services/reservation/internethautdebit.svg";
import { ReactComponent as MicrophoneIcon } from "assets/services/reservation/micro.svg";
import { ReactComponent as PaperboardIcon } from "assets/services/reservation/paperboard.svg";
import { ReactComponent as PauseIcon } from "assets/services/reservation/pause.svg";
import { ReactComponent as StyloEtBlocNoteIcon } from "assets/services/onsite/styloetblocnote.svg";
import { ReactComponent as TelephonieIcon } from "assets/services/onsite/telephonie.svg";
import { ReactComponent as VideoconferenceIcon } from "assets/services/onsite/videoconference.svg";
import { ReactComponent as VisioconferenceIcon } from "assets/services/onsite/visioconference.svg";
import { ReactComponent as BuffetIcon } from "assets/services/onsite/buffet.svg";
import { ReactComponent as CocktailIcon } from "assets/services/onsite/cocktail.svg";
import { ReactComponent as ImpressionCouleurIcon } from "assets/services/onsite/impressioncouleur.svg";
import { ReactComponent as ImpressionNbIcon } from "assets/services/onsite/impressionnb.svg";
import { ReactComponent as OrdinateursIcon } from "assets/services/onsite/ordinateurs.svg";
import { ReactComponent as PhotocopieCouleurIcon } from "assets/services/onsite/photocopiecouleur.svg";
import { ReactComponent as PhotocopieNbIcon } from "assets/services/onsite/photocopienb.svg";
import { ReactComponent as PlateauxRepasIcon } from "assets/services/onsite/plateauxrepas.svg";

import { ReactComponent as RestaurationAProximiteIcon } from "assets/services/free/restaurationaproximite.svg";
import { ReactComponent as RestaurationSurPlaceIcon } from "assets/services/free/restaurationsurplace.svg";
import { ReactComponent as SalleDAttenteIcon } from "assets/services/free/salledattente.svg";
import { ReactComponent as ServiceConciergeIcon } from "assets/services/free/serviceconcierge.svg";
import { ReactComponent as SignaletiqueIcon } from "assets/services/free/signaletique.svg";
import { ReactComponent as TerrasseIcon } from "assets/services/free/terrasse.svg";
import { ReactComponent as TraiteurIcon } from "assets/services/free/traiteur.svg";
import { ReactComponent as AccesHandicapeIcon } from "assets/services/free/acces-handicape.svg";
import { ReactComponent as AccesTerrasseIcon } from "assets/services/free/accesterrasse.svg";
import { ReactComponent as AccueilMultilingueIcon } from "assets/services/free/accueilmultilingue.svg";
import { ReactComponent as AccueilVisiteursIcon } from "assets/services/free/accueilvisiteurs.svg";
import { ReactComponent as BouclierIcon } from "assets/services/free/bouclier.svg";
import { ReactComponent as ClimatisationIcon } from "assets/services/free/climatisation.svg";
import { ReactComponent as CuisinePartageeIcon } from "assets/services/free/cuisinepartagee.svg";
import { ReactComponent as DistributeurBoissonIcon } from "assets/services/free/distributeurboisson.svg";
import { ReactComponent as DistributeurNourritureIcon } from "assets/services/free/distributeurnourriture.svg";
import { ReactComponent as EauIcon } from "assets/services/free/eau.svg";
import { ReactComponent as ErpIcon } from "assets/services/free/erp.svg";
import { ReactComponent as EspaceDetenteIcon } from "assets/services/free/espacedetente.svg";
import { ReactComponent as FontaineEauIcon } from "assets/services/free/fontaineeau.svg";
import { ReactComponent as InternetHautDebitIcon } from "assets/services/free/internethautdebit.svg";
import { ReactComponent as LumiereDuJourIcon } from "assets/services/free/lumieredujour.svg";
import { ReactComponent as MicroondeIcon } from "assets/services/free/microonde.svg";
import { ReactComponent as ParkingIcon } from "assets/services/free/parking.svg";
import { ReactComponent as ParkingGratuitIcon } from "assets/services/free/parkinggratuit.svg";
import { ReactComponent as ParkingPayantIcon } from "assets/services/free/parkingpayant.svg";
import { ReactComponent as PriseReseauIcon } from "assets/services/free/prise-reseau.svg";
import {ReactComponent as AdditionalIcon} from "assets/services/additionIcon.svg";

// Create a map of keys to React components
const svgMap = {
  "reservation/pieuvre": PieuvreIcon,
  "reservation/tableaublanc": WhiteboardIcon,
  "reservation/televiseur": TelevisionIcon,
  "reservation/videoprojecteur": VideoProjectorIcon,
  "reservation/wifi": WifiIcon,
  "reservation/boissonfroide": ColdDrinkIcon,
  "reservation/cafe": CoffeeIcon,
  "reservation/eau": WaterIcon,
  "reservation/ecranprojection": ProjectionScreenIcon,
  "reservation/enceintes": SpeakersIcon,
  "reservation/internethautdebit": HighSpeedInternetIcon,
  "reservation/micro": MicrophoneIcon,
  "reservation/paperboard": PaperboardIcon,
  "reservation/pause": PauseIcon,
  "onsite/styloetblocnote": StyloEtBlocNoteIcon,
  "onsite/telephonie": TelephonieIcon,
  "onsite/videoconference": VideoconferenceIcon,
  "onsite/visioconference": VisioconferenceIcon,
  "onsite/buffet": BuffetIcon,
  "onsite/cocktail": CocktailIcon,
  "onsite/impressioncouleur": ImpressionCouleurIcon,
  "onsite/impressionnb": ImpressionNbIcon,
  "onsite/ordinateurs": OrdinateursIcon,
  "onsite/photocopiecouleur": PhotocopieCouleurIcon,
  "onsite/photocopienb": PhotocopieNbIcon,
  "onsite/plateauxrepas": PlateauxRepasIcon,
  "free/restaurationaproximite": RestaurationAProximiteIcon,
  "free/restaurationsurplace": RestaurationSurPlaceIcon,
  "free/salledattente": SalleDAttenteIcon,
  "free/serviceconcierge": ServiceConciergeIcon,
  "free/signaletique": SignaletiqueIcon,
  "free/terrasse": TerrasseIcon,
  "free/traiteur": TraiteurIcon,
  "free/acces-handicape": AccesHandicapeIcon,
  "free/accesterrasse": AccesTerrasseIcon,
  "free/accueilmultilingue": AccueilMultilingueIcon,
  "free/accueilvisiteurs": AccueilVisiteursIcon,
  "free/bouclier": BouclierIcon,
  "free/climatisation": ClimatisationIcon,
  "free/cuisinepartagee": CuisinePartageeIcon,
  "free/distributeurboisson": DistributeurBoissonIcon,
  "free/distributeurnourriture": DistributeurNourritureIcon,
  "free/eau": EauIcon,
  "free/erp": ErpIcon,
  "free/espacedetente": EspaceDetenteIcon,
  "free/fontaineeau": FontaineEauIcon,
  "free/internethautdebit": InternetHautDebitIcon,
  "free/lumieredujour": LumiereDuJourIcon,
  "free/microonde": MicroondeIcon,
  "free/parking": ParkingIcon,
  "free/parkinggratuit": ParkingGratuitIcon,
  "free/parkingpayant": ParkingPayantIcon,
  "free/prise-reseau": PriseReseauIcon,

};

export default svgMap;
